// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3ed35e5","865":"239afe35"}[chunkId] + ".chunk.js";
};